import React, { Component } from "react";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class SearchInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value:
                props.type === "checkbox"
                    ? (props.isChecked ?? false)
                    : (props.value ?? "")
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.type === "checkbox") {
            if (
                prevProps.isChecked !== this.props.isChecked &&
                this.props.isChecked !== undefined
            ) {
                this.setState({ value: this.props.isChecked });
            }
            return;
        }

        if (
            prevProps.value !== this.props.value &&
            this.props.value !== undefined
        ) {
            this.setState({ value: this.props.value });
        }
    }

    handleChange = (e) => {
        const value =
            e.target.type === "checkbox"
                ? e.target.checked
                : e.target.value;

        this.setState({ value });

        // The clear cross (and Escape) of a type="search" input fires an input event
        // without inputType; typing and Backspace always have one. Submit a clear right away.
        if (value === "" && !e.nativeEvent.inputType) {
            this.props.onChange(value);
        }
    };

    handleKeyDown = (e) => {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange();
        }
    };

    triggerChange = () => {
        this.props.onChange(this.state.value);
    };

    render() {
        const { isChecked, value, onChange, style, ...rest } = this.props;
        const isCheckbox = rest.type === "checkbox";

        return (
            <input
                {...rest}
                value={!isCheckbox ? this.state.value ?? "" : undefined}
                checked={isCheckbox ? !!this.state.value : undefined}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                style={{
                    width: !isCheckbox ? "100%" : undefined,
                    ...style
                }}
            />
        );
    }
}

export default SearchInput;